const routeConfig = {
  login: '/',
  claimList: '/claim-list',
  claimWizard: '/wizard',
  postSubmit: '/post-submit',
  postSubmitSCTI: '/post-submit-scti',
};

export default routeConfig;



// WEBPACK FOOTER //
// ./app/utils/routeConfig.js